import { Injectable } from '@angular/core';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  HttpProviderService,
  ModifyFn,
  CriteriaQuery,
  LookUpFn
} from '@fpx/core';
import { IHttpSuccessPayload } from '@fpx/core';
import { map, of, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AdaFormService implements BaseFpxDataService<any> {
  constructor(private _httpProvider: HttpProviderService) {}

  create(payload: any): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/ada-info-details');
      httpRequest.setBody(payload);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  findByKey(key: { appRef: string }): FindByKeyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/ada-info-details/{appRef}');
      httpRequest.addPathParameter('appRef', key.appRef);
      httpRequest.setMethod('GET');
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<any>) => {
          const data = res.body?.adaform ?? res.body ?? null;
          if (!data || typeof data !== 'object') return data;
          return {
            affirmation: data.affirmation,
            remarks: data.remarks,
            appref: data.appref ?? data.appRef,
            payrollAccount: data.payroll_account ?? data.payrollAccount,
            adaType: data.ada_type ?? data.adaType,
            paymentOption: data.payment_option ?? data.paymentOption ?? data.direct_debit ?? data.directDebit
          };
        }),
        catchError(() => of(null))
      );
    };
  }

  modify(payload: any): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/ada-info-details/{appRef}');
      httpRequest.addPathParameter('appRef', payload.appref ?? payload.appRef);
      httpRequest.setMethod('PUT');
      httpRequest.setBody(payload);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  findAll(criteriaQuery: CriteriaQuery): FindAllFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/ada-info-details');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<any>) => res.body?.adaform ?? []),
        catchError(() => of([]))
      );
    };
  }

  lookup(key: unknown): LookUpFn<any> {
    return () => of([]);
  }
}
